import { render, staticRenderFns } from "./IconTickSquare.vue?vue&type=template&id=30d4f9d9&scoped=true&"
import script from "./IconTickSquare.vue?vue&type=script&lang=js&"
export * from "./IconTickSquare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d4f9d9",
  null
  
)

export default component.exports